import {
  FolderTree, Database, Contact, FileCheck2, Trash, LayoutDashboard, Users, ClipboardList, LayoutGrid, Tag, HeartHandshake,
  Briefcase, MessageSquare, Stethoscope, Scissors, Sparkles, UserCog, UserCheck, ShieldCheck, Building2,
  Building, Wrench, Calendar, Megaphone, BarChart3, PieChart, TrendingUp, Syringe, CalendarDays,
  MessageSquareText, ClipboardCheck, FileText, BookOpen, DollarSign, Warehouse, Globe, CheckSquare, Network,
  PenTool, MonitorSmartphone, UserPlus, CircleDollarSign, Repeat, Wand2, Activity, FileEdit, FileSignature,
  AlertCircle, Undo2, CornerUpRight, CornerUpLeft, FileInput, ReceiptText, FileSpreadsheet, AlarmClockCheck,
  Landmark, CalendarClock, MapPinCheck, Receipt, Workflow, Signature, Headset, MessagesSquare, Store,
  ShoppingCart, ArrowLeftRight, TicketPercent, Upload, Smile, Grid, Zap, Wallet, LineChart, ListChecks, Boxes,
  Hourglass, LogOut, Handshake, Archive, FileClock, Settings2, CalendarHeart, HandCoins,UserRound, CreditCard, RotateCcw, Banknote, Calculator,
  SquareCheck,ArrowRightLeft,Flag, TicketCheck, ScanLine, Package,
  PhoneCall, AlertTriangle, Star, ListTodo, DoorOpen,
  ShoppingBag, BookOpenCheck, Percent,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { MenuUrl } from '../../config/permissions';

/**
 * Cấu hình DUY NHẤT cho menu ứng dụng (drawer bên trái) và sidebar dọc của từng ứng dụng.
 *
 * - App có `pages`: sidebar dọc hiện các trang con; bấm app trong drawer sẽ mở trang con
 *   đầu tiên mà người dùng có quyền.
 * - App chỉ có `link`: không có sidebar dọc (hiện logo nổi để mở drawer).
 * - App đang mở được tính hoàn toàn từ URL (khớp tiền tố dài nhất), không phụ thuộc thao tác bấm.
 */

export interface AppPage {
  title: string;
  url: MenuUrl;
  icon: LucideIcon;
  /** Trang con (không có trên menu) mà mục này được tô sáng khi đang mở */
  activePrefixes?: string[];
}

export interface AppEntry {
  /** Tên hiển thị, đồng thời là khoá — không được trùng */
  name: string;
  icon: LucideIcon;
  bg: string;
  color: string;
  pages?: AppPage[];
  link?: MenuUrl;
  /** Tiền tố URL khác thuộc app này (trang chi tiết / thêm mới không nằm trên menu) */
  prefixes?: string[];
}

export interface AppGroup {
  title: string;
  apps: AppEntry[];
}

export const HOME_APP_NAME = 'Trang chủ';

/** Sidebar mặc định khi URL không thuộc ứng dụng nào */
export const HOME_PAGES: AppPage[] = [
  { title: 'Trang chủ', url: '/', icon: LayoutDashboard },
  { title: 'Công việc', url: '/work-report', icon: ClipboardList },
  { title: 'Dự án', url: '/projects', icon: Briefcase },
  { title: 'Việc lặp', url: '/work-list', icon: Repeat },
  { title: 'Chấm công', url: '/timesheet', icon: CalendarDays },
  { title: 'Lương', url: '/salary', icon: CircleDollarSign },
  { title: 'Tùy chỉnh', url: '/#', icon: Wand2 },
];

export const APP_GROUPS: AppGroup[] = [
  {
    title: 'Làm việc chung',
    apps: [
      { name: 'Mạng nội bộ', link: '/social', icon: Globe, bg: 'bg-blue-100', color: 'text-blue-500' },
      // Mở màn Chat của Telesale: có menu dọc bên trái như Telesales (/chats cũng chuyển về đây)
      { name: 'Chat', link: '/telesales/chats', prefixes: ['/chat'], icon: MessageSquare, bg: 'bg-cyan-100', color: 'text-cyan-600' },
      {
        name: 'Công việc', icon: CheckSquare, bg: 'bg-green-100', color: 'text-green-500',
        pages: [
          { title: 'Dashboard', url: '/work-report', icon: LayoutDashboard },
          { title: 'Dự án', url: '/projects', icon: Briefcase },
          { title: 'Công việc', url: '/work-list', icon: CheckSquare },
          { title: 'Timesheet', url: '/work-calender', icon: Calendar },
        ],
      },
      {
        name: 'Tư vấn cơ sở', icon: Headset, bg: 'bg-red-100', color: 'text-red-500',
        // Menu theo danh sách nhiều khách; 5 bước của từng khách (phiếu tư vấn → chuyển thực hiện) nằm trong hồ sơ khách
        pages: [
          { title: 'Tổng quan hôm nay', url: '/tong-quan-tu-van', icon: LayoutDashboard },
          { title: 'Khách đang chờ', url: '/app-tuvan', icon: Users },
          {
            title: 'Khách đang tư vấn', url: '/khach-tu-van', icon: MessagesSquare,
            activePrefixes: ['/phieu-tu-van', '/bac-si-kham', '/phieu-bao-gia', '/ke-hoach-thanh-toan', '/coc-tai-co-so', '/khai-bao', '/ket-qua-tu-van', '/chuyen-thuc-hien'],
          },
          { title: 'Thanh toán theo đợt', url: '/thanh-toan-dot', icon: CircleDollarSign },
        ],
        prefixes: ['/phieu-tu-van', '/bac-si-kham', '/phieu-bao-gia', '/ke-hoach-thanh-toan', '/coc-tai-co-so', '/ket-qua-tu-van', '/chuyen-thuc-hien'],
      },
      // {
      //   name: 'App CSKH', icon: BarChart3, bg: 'bg-violet-100', color: 'text-violet-600',
      //   pages: [
      //     { title: 'Tổng quan', url: '/tong-quan-cskh', icon: TrendingUp },
      //     { title: 'Khách hàng (CS0–CS6)', url: '/app-cskh/khach-hang', icon: Users },
      //     { title: 'Tổng đài CSKH', url: '/app-cskh/tong-dai-cskh', icon: PhoneCall },
      //     { title: 'Công việc', url: '/app-cskh/cong-viec-cskh', icon: ListTodo },
      //     { title: 'Lịch', url: '/app-cskh/lich-cham-soc', icon: CalendarDays },
      //     { title: 'Khiếu nại', url: '/app-cskh/khieu-nai', icon: AlertTriangle },
      //     { title: 'Khảo sát', url: '/app-cskh/khao-sat', icon: Star },
      //   ],
      // },
      {
        name: 'Tài liệu', icon: BookOpen, bg: 'bg-orange-100', color: 'text-orange-500',
        pages: [
          { title: 'Tổng quan', url: '/document-dashboard', icon: LayoutDashboard },
          { title: 'Cá nhân', url: '/personal-documents', icon: UserCheck },
          { title: 'Quản lý', url: '/document-management', icon: PenTool },
          { title: 'Tạo mới', url: '/add-new-document', icon: FileSignature },
          { title: 'Duyệt', url: '/document-approval', icon: FileCheck2 },
          { title: 'Danh mục', url: '/list-of-documents', icon: FolderTree },
          { title: 'Loại', url: '/document-type', icon: Activity },
          { title: 'Thùng rác', url: '/document-trash', icon: Trash },
        ],
      },
      {
        name: 'Trình ký', icon: Signature, bg: 'bg-red-100', color: 'text-red-500',
        pages: [
          { title: 'Quy trình', url: '/request', icon: Workflow },
          { title: 'Quản lý', url: '/submit-for-signature', icon: FileText },
          { title: 'Ký ảnh', url: '/digital-signature', icon: Signature },
          { title: 'Cảnh báo', url: '/#', icon: Megaphone },
        ],
      },
      {
        name: 'Tài sản', icon: MonitorSmartphone, bg: 'bg-green-100', color: 'text-green-500',
        pages: [
          { title: 'Dashboard', url: '/assets', icon: Activity },
          { title: 'Tài sản', url: '/assets/list', icon: FileEdit },
          { title: 'Cấp phát', url: '/assets/allocation', icon: CornerUpRight },
          { title: 'Thu hồi', url: '/assets/recall', icon: CornerUpLeft },
        ],
      },
    ],
  },
  {
    title: 'Nhân sự',
    apps: [
      {
        name: 'Nhân sự', icon: Users, bg: 'bg-blue-100', color: 'text-blue-500',
        prefixes: ['/contract-management'],
        pages: [
          { title: 'Dashboard', url: '/personnel-management/dashbroad', icon: LayoutDashboard },
          { title: 'Hồ sơ', url: '/personnel-management', icon: Users },
          { title: 'Hợp đồng', url: '/employment-contract', icon: FileSignature },
          { title: 'Thử việc', url: '/probation', icon: Hourglass },
          { title: 'Nghỉ việc', url: '/offboarding', icon: LogOut },
          { title: 'Định biên', url: '/headcount-plan', icon: LayoutGrid },
          { title: 'Quyết định', url: '/decision', icon: FileText },
        ],
      },
      {
        name: 'Tuyển dụng', icon: UserPlus, bg: 'bg-green-100', color: 'text-green-500',
        prefixes: ['/job', '/candidate', '/candidate-detail'],
        pages: [
          { title: 'Dashboard', url: '/recruitment', icon: LayoutDashboard },
          { title: 'Yêu cầu', url: '/jobs-view', icon: Briefcase },
          { title: 'Ứng viên', url: '/candidates-view', icon: Users },
          { title: 'Phỏng vấn', url: '/interviews', icon: CalendarClock },
          { title: 'Offer', url: '/offers', icon: Handshake },
          { title: 'Kho hồ sơ', url: '/talent-pool', icon: Archive },
        ],
      },
      {
        name: 'Chấm công', icon: AlarmClockCheck, bg: 'bg-red-100', color: 'text-red-500',
        pages: [
          { title: 'Dashboard', url: '/timekeeping', icon: LayoutDashboard },
          { title: 'Phân ca', url: '/task-assignment', icon: CalendarDays },
          { title: 'Chấm công', url: '/timesheet', icon: CalendarClock },
          { title: 'Đơn từ', url: '/time-requests', icon: FileClock },
          { title: 'Phép năm', url: '/leave-balance', icon: CalendarHeart },
          { title: 'Ca làm', url: '/shifts', icon: Settings2 },
          { title: 'Báo cáo', url: '/timekeeping-reports', icon: Megaphone },
        ],
      },
      {
        name: 'Bảng lương', icon: DollarSign, bg: 'bg-green-100', color: 'text-green-500',
        pages: [
          { title: 'Kỳ lương', url: '/salary', icon: DollarSign },
          { title: 'Tạm ứng', url: '/salary-advances', icon: HandCoins },
          { title: 'Phiếu lương', url: '/payslips', icon: ReceiptText },
          { title: 'Thiết lập', url: '/payroll-settings', icon: Settings2 },
          { title: 'TNCN', url: '/pit', icon: Receipt },
        ],
      },
      { name: 'Sơ đồ tổ chức', link: '/so-do-to-chuc', icon: Network, bg: 'bg-orange-100', color: 'text-orange-500' },
      // Tạm ẩn — trang /tien-trinh vẫn giữ route
      // { name: 'Tiến trình', link: '/tien-trinh', icon: Route, bg: 'bg-red-100', color: 'text-red-500' },
    ],
  },
  {
    title: 'Khách hàng & CSKH',
    apps: [
      {
        name: 'Khách hàng', icon: Users, bg: 'bg-blue-100', color: 'text-blue-500',
        prefixes: ['/appointment', '/consultation'],
        pages: [
          { title: 'Dashboard', url: '/dashbroad-truc-page', icon: LayoutDashboard },
          { title: 'Khách hàng', url: '/customer', icon: Users },
          { title: 'Lịch hẹn', url: '/appointments', icon: CalendarDays },
          { title: 'Tư vấn', url: '/consultations', icon: MessagesSquare },
          { title: 'Thực hiện', url: '/execution-schedule', icon: ClipboardCheck },
        ],
      },
      { name: 'Check-in', link: '/check-in', icon: MapPinCheck, bg: 'bg-yellow-100', color: 'text-yellow-500' },
      {
        name: 'CSKH', icon: Headset, bg: 'bg-orange-100', color: 'text-orange-500',
        pages: [
          { title: 'Tổng quan', url: '/cskh-dashboard', icon: LayoutDashboard },
          { title: 'Tổng đài', url: '/customer-demo', icon: Headset },
          { title: 'Công việc', url: '/cskh-tasks', icon: ListChecks },
          { title: 'Lịch', url: '/care-list', icon: HeartHandshake },
          { title: 'Khiếu nại', url: '/cskh-complaints', icon: AlertCircle },
          { title: 'Khảo sát', url: '/cskh-surveys', icon: ClipboardCheck },
        ],
      },
      {
        name: 'Chuyên môn', icon: Stethoscope, bg: 'bg-teal-100', color: 'text-teal-600',
        pages: [
          { title: 'Cấy Tóc', url: '/hair-clinic', icon: Sparkles },
          { title: 'Giảm Mỡ (Miko)', url: '/miko-reception', icon: Activity },
          { title: 'Phẫu Thuật', url: '/cosmetic-surgery-reception', icon: Scissors },
          { title: 'Căng Chỉ', url: '/thread-lift-reception', icon: Syringe },
          { title: 'Ozempic', url: '/consultation-form', icon: FileSpreadsheet },
          { title: 'Tư Vấn (Mặt)', url: '/beauty-consultation', icon: Smile },
          { title: 'Tư Vấn Da', url: '/consultation-tabs', icon: UserCheck },
        ],
      },
      {
        name: 'Lễ tân', icon: UserRound, bg: 'bg-red-100', color: 'text-red-500',
        // Họp 30/10: Lễ tân chỉ làm check-in → hàng chờ tư vấn / hàng chờ thực hiện (POS ở Bán hàng, trừ buổi ở App Nội khoa)
        pages: [
          { title: 'Hàng chờ tư vấn · thực hiện', url: '/reception-checkin', icon: SquareCheck },
          { title: 'Kiosk check-in', url: '/check-in', icon: ScanLine },
        ]
      },
      {
        name: 'Telesale', icon: Database, bg: 'bg-purple-100', color: 'text-purple-500',
        // Lịch sử chia lại khách: mở từ Cài đặt chia lại, không nằm trên menu
        prefixes: ['/telesales/reassign-history'],
        pages: [
          { title: 'Dashboard', url: '/telesales/dashboard', icon: LayoutDashboard },
          { title: 'Chat', url: '/telesales/chats', icon: MessageSquare },
          { title: 'Khách tiềm năng', url: '/telesales/customer', icon: Contact },
          { title: 'Tổng đài Sales', url: '/telesales/call-center', icon: Headset },
          { title: 'Lịch hẹn', url: '/telesales/appointments', icon: CalendarClock },
          { title: 'Lịch tư vấn', url: '/telesales/consultations', icon: MessagesSquare },
          { title: 'Đối soát cọc', url: '/telesales/deposits', icon: Receipt },
        ]
      }
    ],
  },
  {
    title: 'Bán hàng & Vận hành',
    apps: [
      {
        name: 'POS', icon: Store, bg: 'bg-purple-100', color: 'text-purple-500',
        pages: [
          { title: 'Bán hàng', url: '/pos', icon: ShoppingCart },
          { title: 'Điều phối phòng', url: '/pos/dispatch', icon: DoorOpen },
          { title: 'Đơn hàng', url: '/pos/orders', icon: ReceiptText },
          { title: 'Đơn nháp', url: '/pos/drafts', icon: FileText },
          { title: 'Giao dịch', url: '/pos/transactions', icon: ArrowLeftRight },
          { title: 'Hoàn tiền', url: '/pos/refunds', icon: Undo2 },
          { title: 'Khuyến mãi', url: '/pos/promotions', icon: TicketPercent },
          { title: 'Import', url: '/pos/import', icon: Upload },
          { title: 'Thống kê', url: '/pos/dashboard', icon: BarChart3 },
        ],
      },
      {
        // Họp 30/10: app Liệu trình đổi thành App Nội khoa (sau có thêm App Ngoại khoa, App Cấy tóc); thiết lập gói chuyển về app Dịch vụ
        name: 'Nội khoa', icon: TicketCheck, bg: 'bg-cyan-100', color: 'text-cyan-600',
        pages: [
          { title: 'Tổng quan', url: '/treatment', icon: LayoutDashboard },
          { title: 'Khách hàng · thẻ', url: '/treatment/cards', icon: TicketCheck },
          { title: 'Trừ buổi', url: '/treatment/checkin', icon: ScanLine },
          { title: 'Công nợ thẻ', url: '/treatment/debts', icon: HandCoins },
        ],
      },
      {
        name: 'Dịch vụ', icon: Wrench, bg: 'bg-stone-100', color: 'text-stone-600',
        pages: [
          { title: 'Danh mục', url: '/services', icon: FolderTree },
          { title: 'Dịch vụ lẻ', url: '/services-list', icon: Wrench },
          { title: 'Liệu trình', url: '/treatment/packages', icon: Package },
        ],
      },
      {
        name: 'Sản phẩm', icon: ShoppingBag, bg: 'bg-amber-100', color: 'text-amber-600',
        pages: [
          { title: 'Sản phẩm', url: '/products', icon: ShoppingBag },
        ],
      },
      {
        name: 'Kho hàng', icon: Warehouse, bg: 'bg-green-100', color: 'text-green-500',
        prefixes: ['/sales-contract', '/purchase-order', '/report-list'],
        pages: [
          { title: 'Tổng quan', url: '/warehouse-dashboard', icon: LayoutDashboard },
          { title: 'Tồn kho', url: '/warehouses', icon: Boxes },
          { title: 'Phiếu kho', url: '/import-export', icon: FileInput },
          { title: 'Kiểm kho', url: '/inventory-count', icon: ClipboardCheck },
          { title: 'Vật tư', url: '/warehouse-items', icon: Syringe },
          { title: 'Định mức DV', url: '/service-norms', icon: ListChecks },
          { title: 'NCC', url: '/supplier', icon: Warehouse },
          { title: 'Báo cáo', url: '/inventory', icon: BarChart3 },
        ],
      },
      {
        name: 'Kế toán quầy', icon: Banknote, bg: 'bg-emerald-100', color: 'text-emerald-600',
        pages: [
          { title: 'Thu tiền tại quầy', url: '/ke-toan/counter', icon: Banknote },
          { title: 'Bill trong ngày', url: '/ke-toan/counter-bills', icon: Receipt },
          { title: 'Ca thực hiện', url: '/ke-toan/sessions', icon: Stethoscope },
          { title: 'Chốt ca', url: '/ke-toan/shift', icon: ClipboardCheck },
        ],
      },
      {
        name: 'Kế toán nội bộ', icon: Calculator, bg: 'bg-teal-100', color: 'text-teal-600',
        pages: [
          { title: 'Tổng quan', url: '/ke-toan', icon: LayoutDashboard },
          { title: 'Duyệt khóa sổ', url: '/ke-toan/bills', icon: Receipt },
          { title: 'Nhận biên bản ca', url: '/ke-toan/shift-review', icon: ClipboardCheck },
          { title: 'Đối soát', url: '/ke-toan/reconcile', icon: ArrowLeftRight },
          { title: 'Thẻ liệu trình', url: '/ke-toan/cards', icon: CreditCard },
          { title: 'Cọc, công nợ', url: '/ke-toan/deposits', icon: Wallet },
          { title: 'Hoàn tiền thẻ', url: '/ke-toan/refunds', icon: RotateCcw },
          { title: 'Hoa hồng, tua', url: '/ke-toan/commission', icon: HandCoins },
        ],
      },
      {
        name: 'Kế toán tổng hợp', icon: BookOpenCheck, bg: 'bg-sky-100', color: 'text-sky-600',
        pages: [
          { title: 'Hóa đơn', url: '/ke-toan/invoices', icon: ReceiptText },
          { title: 'Thuế suất, bảng giá', url: '/ke-toan/tax-rates', icon: Percent },
          { title: 'Kê khai GTGT', url: '/ke-toan/tax-return', icon: FileSpreadsheet },
          { title: 'Sổ Thuế, Sổ Quản trị', url: '/ke-toan/books', icon: BookOpenCheck },
        ],
      },
      {
        name: 'Tài chính', icon: DollarSign, bg: 'bg-red-100', color: 'text-red-500',
        prefixes: ['/expense-detail', '/debt', '/debt-detail', '/debt-contract'],
        pages: [
          { title: 'Dashboard', url: '/#', icon: LayoutDashboard },
          { title: 'Phiếu thu', url: '/revenue', icon: ReceiptText },
          { title: 'Phiếu chi', url: '/expense', icon: FileSpreadsheet },
          { title: 'Ngân sách', url: '/budget', icon: PieChart },
          { title: 'Ngân hàng', url: '/bank-list', icon: Landmark },
        ],
      },
    ],
  },
  {
    title: 'Marketing & Báo cáo',
    apps: [
      {
        name: 'BCCD', icon: Megaphone, bg: 'bg-rose-100', color: 'text-rose-500',
        pages: [
          { title: 'Báo cáo', url: '/marketing-campaign-report', icon: BarChart3 },
          { title: 'QL Tiền Tố Chiến Dịch', url: '/advertising-campaign-management', icon: Wallet },
          { title: 'Chiến dịch quảng cáo', url: '/advertising-campaign', icon: Megaphone },
        ],
      },
      {
        name: 'Báo cáo', icon: BarChart3, bg: 'bg-violet-100', color: 'text-violet-600',
        pages: [
          { title: 'Báo cáo Sale Online', url: '/sale-online-report', icon: TrendingUp },
          { title: 'Báo cáo khách hàng', url: '/customer-report', icon: Users },
          { title: 'Báo cáo Marketing', url: '/marketing-report', icon: LineChart },
          { title: 'Báo cáo CCO', url: '/bao-cao-cco', icon: PhoneCall },
        ],
      },
    ],
  },
  {
    title: 'Quản trị',
    apps: [
      {
        name: 'Cài đặt', icon: UserCog, bg: 'bg-sky-100', color: 'text-sky-600',
        pages: [
          { title: 'Nhân Viên', url: '/employee', icon: Users },
          { title: 'Nhóm quyền', url: '/group-roles', icon: ShieldCheck },
          { title: 'Phòng ban', url: '/departments', icon: Building },
          { title: 'Chi nhánh', url: '/branch-manager', icon: Building2 },
          // Cài đặt Telesale (nhóm dịch vụ & chia số, ngưỡng vận hành, chia lại khách) — giữ đường dẫn cũ cho nút Cài đặt trên Dashboard Telesale
          { title: 'Cài đặt Telesale', url: '/telesales/settings', icon: Settings2 },
        ],
      },
      {
        name: 'Danh mục', icon: LayoutGrid, bg: 'bg-yellow-100', color: 'text-yellow-600',
        pages: [
          { title: 'Thẻ sale', url: '/customer-tags', icon: Tag },
          { title: 'Ma trận trạng thái', url: '/appointment-transitions', icon: Grid },
          { title: 'Thẻ chat', url: '/care-status', icon: MessageSquareText },
          { title: 'Ngành Nghề', url: '/profession', icon: Briefcase },
          { title: 'Tin nhắn nhanh', url: '/quick-messages', icon: Zap },
        ],
      },
    ],
  },
];

export const ALL_APPS: AppEntry[] = APP_GROUPS.flatMap((g) => g.apps);

type CanSee = (url: MenuUrl) => boolean;

const matchesPrefix = (path: string, prefix: string) =>
  prefix !== '/#' && (path === prefix || path.startsWith(prefix.endsWith('/') ? prefix : prefix + '/'));

/**
 * App chứa URL hiện tại — khớp tiền tố dài nhất; trùng độ dài thì app có sidebar dọc (`pages`) thắng
 * (vd app Chat chỉ là lối tắt tới trang Chat của Telesale), còn lại app khai báo trước thắng. `null` = Trang chủ.
 */
export function findAppByPath(path: string): AppEntry | null {
  let best: AppEntry | null = null;
  let bestLen = 0;
  for (const app of ALL_APPS) {
    const prefixes = [...(app.pages ?? []).map((p) => p.url), ...(app.link ? [app.link] : []), ...(app.prefixes ?? [])];
    for (const prefix of prefixes) {
      const longer = prefix.length > bestLen || (prefix.length === bestLen && !!app.pages && !best?.pages);
      if (longer && matchesPrefix(path, prefix)) {
        best = app;
        bestLen = prefix.length;
      }
    }
  }
  return best;
}

/** Trang con người dùng được xem */
export const visiblePages = (app: AppEntry, canSee: CanSee): AppPage[] =>
  (app.pages ?? []).filter((p) => canSee(p.url));

/** URL mở khi bấm app: `link`, hoặc trang con đầu tiên có quyền. `null` = không có quyền vào app này. */
export function appEntryUrl(app: AppEntry, canSee: CanSee): MenuUrl | null {
  if (app.link) return canSee(app.link) ? app.link : null;
  return visiblePages(app, canSee)[0]?.url ?? null;
}

/** Số lần mở từng app trên máy này (theo tên app) — trang chủ đưa app hay dùng lên đầu */
const USAGE_KEY = 'khothi.appUsage';
export type AppUsage = Record<string, { n: number; at: number }>;

export function readAppUsage(): AppUsage {
  try {
    const raw = JSON.parse(localStorage.getItem(USAGE_KEY) || '{}');
    return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  } catch {
    return {};
  }
}

export function recordAppUse(name: string, now = Date.now()) {
  const usage = readAppUsage();
  usage[name] = { n: (usage[name]?.n ?? 0) + 1, at: now };
  try { localStorage.setItem(USAGE_KEY, JSON.stringify(usage)); } catch { /* bỏ qua */ }
}

/** Xếp app hay dùng lên trước (nhiều lần mở hơn, rồi mở gần đây hơn); app chưa dùng giữ thứ tự menu */
export function sortByUsage<T extends { app: AppEntry }>(items: T[], usage: AppUsage): T[] {
  const n = (x: T) => usage[x.app.name]?.n ?? 0;
  const at = (x: T) => usage[x.app.name]?.at ?? 0;
  return [...items].sort((a, b) => n(b) - n(a) || at(b) - at(a));
}

/** App người dùng ghim lên đầu trang chủ (theo tên app, đúng thứ tự ghim) */
const PINNED_KEY = 'khothi.pinnedApps';

export function readPinnedApps(): string[] {
  try {
    const raw = JSON.parse(localStorage.getItem(PINNED_KEY) || '[]');
    return Array.isArray(raw) ? raw.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function savePinnedApps(names: string[]) {
  try { localStorage.setItem(PINNED_KEY, JSON.stringify(names)); } catch { /* bỏ qua */ }
}

/** Thứ tự "Tất cả ứng dụng" người dùng tự sắp; `null` = xếp theo mức dùng */
const ORDER_KEY = 'khothi.appOrder';

export function readAppOrder(): string[] | null {
  try {
    const raw = JSON.parse(localStorage.getItem(ORDER_KEY) || 'null');
    return Array.isArray(raw) ? raw.filter((x) => typeof x === 'string') : null;
  } catch {
    return null;
  }
}

export function saveAppOrder(names: string[] | null) {
  try {
    if (names) localStorage.setItem(ORDER_KEY, JSON.stringify(names));
    else localStorage.removeItem(ORDER_KEY);
  } catch { /* bỏ qua */ }
}

/** Xếp theo thứ tự đã sắp; app chưa có trong danh sách (app mới) nối cuối, giữ thứ tự sẵn có (mức dùng) */
export function applyAppOrder<T extends { app: AppEntry }>(items: T[], order: string[] | null): T[] {
  if (!order) return items;
  const rank = (x: T) => {
    const i = order.indexOf(x.app.name);
    return i < 0 ? order.length : i;
  };
  return [...items].sort((a, b) => rank(a) - rank(b));
}

/** Đưa `name` tới vị trí `to` trong `shown`; tên không hiện (đã ghim / mất quyền) giữ thứ tự cũ ở cuối */
export function moveInOrder(shown: string[], name: string, to: number, prev: string[] = []): string[] {
  const next = shown.filter((n) => n !== name);
  next.splice(Math.max(0, Math.min(to, next.length)), 0, name);
  return [...next, ...prev.filter((n) => !next.includes(n))];
}

/** Bỏ dấu tiếng Việt để tìm "phieu chi" ra "Phiếu chi" */
export const normalizeText = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase().trim();

export interface AppSearchResult {
  app: AppEntry;
  /** `undefined` = khớp tên app */
  page?: AppPage;
  url: MenuUrl;
}

export function searchApps(keyword: string, canSee: CanSee): AppSearchResult[] {
  const q = normalizeText(keyword);
  if (!q) return [];
  const results: AppSearchResult[] = [];
  for (const app of ALL_APPS) {
    const entry = appEntryUrl(app, canSee);
    if (!entry) continue;
    const appHit = normalizeText(app.name).includes(q);
    if (appHit) results.push({ app, url: entry });
    for (const page of visiblePages(app, canSee)) {
      if (normalizeText(page.title).includes(q)) {
        results.push({ app, page, url: page.url });
      }
    }
  }
  return results;
}
